
// SVG Icon: splitterOff
export default { id: "terriajs-splitterOff" };
export const id = "terriajs-splitterOff";
export const name = "splitterOff";
